// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IBlockLayer {
  block_name: string;
  count: number;
}
